import styled from 'styled-components'

export const Container = styled.div`
   form {
    h2 {
      display: none;
    }
   }

   margin-left: 48px;

   @media(max-width: 600px) {
    margin-left: 0;
   }

   @media(max-width: 440px) {
    > div {
		  width: 90%;
    }
   }
`
